export const replaceElement = (arr, predicate, newElement) => {
    const index = arr.findIndex(predicate);
    if (index !== -1) {
        arr[index] = newElement;
    }
};
export const removeById = (arr, id) => {
    const index = arr.findIndex(layer => layer.id === id);
    if (index !== -1) {
        arr.splice(index, 1);
    }
};
export const replaceById = (arr, id, newElement) => {
    replaceElement(arr, layer => layer.id === id, newElement);
};
export const replaceByName = (arr, name, newElement) => {
    replaceElement(arr, layer => layer.name === name, newElement);
};
export const reorderElement = (arr, from, to) => {
    const [item] = arr.splice(from, 1);
    arr.splice(to, 0, item);
};
